import { type ReactNode } from 'react';

import styles from '../styles/common.module.css';

export function PageHeader({ title, subtitle, actions }: { title: string; subtitle?: ReactNode; actions?: ReactNode }) {
  return (
    <div className={styles.pageHeader}>
      <div>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}

export function Card({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={`${styles.card} ${className ?? ''}`}>{children}</div>;
}

export function StatCard({ label, value, highlight }: { label: string; value: ReactNode; highlight?: boolean }) {
  return (
    <div className={`${styles.statCard} ${highlight ? styles.statHighlight : ''}`}>
      <div className={styles.statLabel}>{label}</div>
      <div className={styles.statValue}>{value}</div>
    </div>
  );
}

export function Field({ label, required, children }: { label: string; required?: boolean; children: ReactNode }) {
  return (
    <div className={styles.formField}>
      <label className={styles.label}>
        {label}
        {required && <span className={styles.required}>*</span>}
      </label>
      {children}
    </div>
  );
}

export function StatusBadge({ status }: { status: 'pending' | 'completed' | 'skipped' | string }) {
  const cls =
    status === 'completed' ? styles.badgeCompleted : status === 'skipped' ? styles.badgeSkipped : styles.badgePending;
  return <span className={`${styles.badge} ${cls}`}>{status}</span>;
}

export function ErrorMessage({ message }: { message?: string | null }) {
  if (!message) return null;
  return <div className={styles.error}>{message}</div>;
}

export function Loading() {
  return <div className={styles.empty}>Loading…</div>;
}
